export default __webpack_public_path__ + "static/media/theme1.8197530e.jpg";